import { css } from 'lit'

export const GroupBarStyles = css`
  :host {
    background-color: var(--group-bar-background-color);

    overflow-x: hidden;
  }

  ul {
    display: flex;
    flex-direction: row;
    box-sizing: border-box;
    list-style: none;
    margin: 0;
    padding: 0;
    white-space: nowrap;
  }

  li {
    display: flex;
    align-items: center;

    box-sizing: border-box;
    border-bottom: var(--group-bar-line);
    align-self: auto;
    min-height: 43px;
    padding: 4px 8px;

    * {
      vertical-align: middle;
    }

    a {
      display: block;
      text-decoration: none;
      font: var(--group-bar-textbutton);
      color: var(--md-sys-color-on-secondary-container);
      opacity: 0.8;
    }

    a md-icon {
      font-variation-settings: 'FILL' 1;
    }

    &[active] {
      border-color: var(--group-bar-active-line-color);

      a {
        font: var(--group-bar-textbutton-active);
        opacity: 1;
      }
    }

    &[padding] {
      flex: 1;
    }

    &[add] * {
      color: var(--md-sys-color-on-secondary-container);
    }
  }
`
